import { Box, Tabs } from "@radix-ui/themes";
import { useAuth } from "@/providers/AuthProvider";

export type UserManagementTab = "users" | "roles" | "groups";

const TAB_PATHS: Record<UserManagementTab, string> = {
  users: "users",
  roles: "roles-and-permissions",
  groups: "groups",
};

// Tabs navigate rather than swap local content, so each page keeps its own access guard.
export default function UserManagementTabs({ active }: { active: UserManagementTab }) {
  const { currentTenant, isTenantAdmin, safeNavigate } = useAuth();

  return (
    <Box mb="4">
      <Tabs.Root
        value={active}
        onValueChange={(tab) =>
          safeNavigate(
            `/org/${currentTenant?.id}/settings/${TAB_PATHS[tab as UserManagementTab]}`,
          )
        }
      >
        <Tabs.List size="2">
          <Tabs.Trigger value="users">Users</Tabs.Trigger>
          {isTenantAdmin && (
            <Tabs.Trigger value="roles">Roles &amp; Permissions</Tabs.Trigger>
          )}
          {isTenantAdmin && <Tabs.Trigger value="groups">Groups</Tabs.Trigger>}
        </Tabs.List>
      </Tabs.Root>
    </Box>
  );
}
